import { NewsItem } from '@/types/schema';

export const newsData = {
    "ปลาร้าเชฟไพรฑูรย์ กินดีมีโชค 2024": {
        id: 1,
        title: "ปลาร้าเชฟไพรฑูรย์ กินดีมีโชค 2024",
        description: "ปลาร้าเชฟไพรฑูรย์ กินดี...มีโชค ",
        imageUrl: "/images/news-events/news1/cover.png",
        content: `กิจกรรม ปลาร้าเชฟไพรฑูรย์ กินดีมีโชค 2024 
ปลาร้าเชฟไพรฑูรย์ กินดี...มีโชค 
รางวัลมูลค่ารวมกว่า 1,000,000 บาท 
#คืนกำไรให้ลูกค้า ฉลองครบรอบ 10 ปี  ขอบพระคุณที่ไว้วางใจและเลือกใช้น้ำปลาร้าเชฟไพรฑูรย์เสมอมา
`,
        galleryImages: [
            '/images/news-events/news1/cover.png',
            '/images/news-events/news1/485423993_1074415744713747_2806407889129903801_n.jpg',
            '/images/news-events/news1/485764867_1074416178047037_8413985326137403228_n.jpg',
            '/images/news-events/news1/485767647_1074415928047062_3213654092126831985_n.jpg',
            '/images/news-events/news1/485872339_1074415964713725_760437633578148832_n.jpg',
            '/images/news-events/news1/486372379_1079209670901021_7919597585293661027_n.jpg',
            '/images/news-events/news1/486639784_1079209727567682_2013617208522937862_n.jpg',
            '/images/news-events/news1/486641554_1079209660901022_6033814244970762821_n.jpg',
            '/images/news-events/news1/487503782_1083697147118940_7519282201707509620_n.jpg',
            '/images/news-events/news1/487506454_1083696960452292_8843679818729463923_n.jpg',
            '/images/news-events/news1/488058724_1085201640301824_1363836398471242124_n.jpg',
            '/images/news-events/news1/488060915_1085200496968605_877024202762421550_n.jpg',
            '/images/news-events/news1/488459449_1085200586968596_2949772356368753034_n.jpg',
            '/images/news-events/news1/488491708_1085201620301826_4023729632597226308_n.jpg',
        ],
    },
    "รณรงค์ป้องกัน แก้ปัญหา ยาเสพติด": {
        id: 2,
        title: "รณรงค์ป้องกัน แก้ปัญหา ยาเสพติด",
        description: "โครงการ รณรงค์ป้องกัน และแก้ปัญหา ยาเสพติด",
        imageUrl: '/images/news-events/news2/486180184_1077578727730782_2057993639538804923_n.jpg',
        content: `โครงการ รณรงค์ป้องกัน และแก้ปัญหา ยาเสพติด`,
        galleryImages: [
            '/images/news-events/news2/486180184_1077578727730782_2057993639538804923_n.jpg',
            '/images/news-events/news2/486505198_1077578504397471_4799935388965642325_n.jpg',
            '/images/news-events/news2/486669143_1077578714397450_2608038802660521444_n.jpg',
            '/images/news-events/news2/486741767_1077578751064113_1266865585686876101_n.jpg',
        ],
    },
    "มอบทุนการศึกษาประจำปี 2567": {
        id: 3,
        title: "มอบทุนการศึกษาประจำปี 2567",
        description: "ในโครงการ สานฝันการศึกษา เพื่ออนาคตที่สดใส",
        imageUrl: '/images/news-events/news3/486814062_1079289320893056_7996896467361051997_n.jpg',
        content: `มอบทุนการศึกษาประจำปี 2567 ในโครงการ สานฝันการศึกษา เพื่ออนาคตที่สดใส`,
        galleryImages: [
            '/images/news-events/news3/486814062_1079289320893056_7996896467361051997_n.jpg',
            '/images/news-events/news3/486647545_1079289317559723_1836577284536488599_n.jpg',
            '/images/news-events/news3/486666548_1079289217559733_1925906099513772402_n.jpg',
            '/images/news-events/news3/486681538_1079289507559704_4526899796331649149_n.jpg',
            '/images/news-events/news3/486769575_1079289277559727_5562916752933550312_n.jpg',
            '/images/news-events/news3/486771599_1079289430893045_6840051976802821275_n.jpg',
            '/images/news-events/news3/486789785_1079289310893057_86910673201818713_n.jpg',
            '/images/news-events/news3/486869734_1079289280893060_8518414365884295100_n.jpg',
            '/images/news-events/news3/487018195_1079289514226370_2901436898954680786_n.jpg',
            '/images/news-events/news3/487069416_1079289510893037_6351552997337966634_n.jpg',
            '/images/news-events/news3/487121951_1079289527559702_1318324866950953115_n.jpg',
            '/images/news-events/news3/487214774_1079289504226371_8547003295903846828_n.jpg',
            '/images/news-events/news3/487220093_1079289627559692_7667852668160640670_n.jpg',
            '/images/news-events/news3/487489697_1079289644226357_5672753443543867930_n.jpg',
        ],
    },
    "สะพานบุญเสริมสร้างต้นทุนแกชีวิต": {
        id: 4,
        title: "สะพานบุญเสริมสร้างต้นทุนแกชีวิต",
        description: "สนับสนุนโครงการ สะพานบุญเสริมสร้างต้นทุนแกชีวิต",
        imageUrl: '/images/news-events/news4/481084468_1059306286224693_6128542971787184880_n.jpg',
        content: `สนับสนุนโครงการ สะพานบุญเสริมสร้างต้นทุนแกชีวิต เพื่อช่วยเหลือผู้ยากไร้ อำเภออุบลรัตน์ จังหวัดขอบนแก่น`,
        galleryImages: [
            '/images/news-events/news4/481084468_1059306286224693_6128542971787184880_n.jpg',
            '/images/news-events/news4/480951032_1059306276224694_5624502370957765171_n.jpg',
            '/images/news-events/news4/480961319_1059306209558034_830998895059641905_n.jpg',
            '/images/news-events/news4/480963059_1059306192891369_5321602208069908086_n.jpg',
            '/images/news-events/news4/481063878_1059306182891370_7791860912701961148_n.jpg',
            '/images/news-events/news4/481189251_1059306169558038_7128211841682977375_n.jpg',
        ],
    },
    "โครงการส่งเสริมและพัฒนาคุณภาพชีวิตประชากร": {
        id: 5,
        title: "โครงการส่งเสริมและพัฒนาคุณภาพชีวิตประชากร",
        description: "กลุ่มเป้าหมายพื้นที่นิคมสร้างตนเอง จังหวัดขอนแก่น ",
        imageUrl: '/images/news-events/news5/488205214_1085352583620063_3955497367008998029_n.jpg',
        content: `ออกบูธ โครงการส่งเสริมและพัฒนาคุณภาพชีวิตประชากรกลุ่มเป้าหมายพื้นที่นิคมสร้างตนเอง จังหวัดขอนแก่น`,
        galleryImages: [
            '/images/news-events/news5/488205214_1085352583620063_3955497367008998029_n.jpg',
            '/images/news-events/news5/487770391_1085352500286738_3598446684097938594_n.jpg',
            '/images/news-events/news5/488009073_1085352526953402_5096646664204657423_n.jpg',
            '/images/news-events/news5/488060923_1085352550286733_4149662589584939905_n.jpg',
            '/images/news-events/news5/488800041_1085352503620071_3678505728269362291_n.jpg',
        ],
    },
    "งานตักบาตรเทโวโรหณะ 2567": {
        id: 6,
        title: "งานตักบาตรเทโวโรหณะ 2567",
        description: "ณ วัดพระบาทภูพานคํา อำเภออุบลรัตน์ จังหวัดขอนแก่น",
        imageUrl: '/images/news-events/news6/487106264_1082229430599045_6523375537342763112_n.jpg',
        content: `ร่วมทำโรงทาน ในงานตักบาตรเทโวโรหณะ 2567 ณ วัดพระบาทภูพานคํา อำเภออุบลรัตน์ จังหวัดขอนแก่น`,
        galleryImages: [
            '/images/news-events/news6/487106264_1082229430599045_6523375537342763112_n.jpg',
            '/images/news-events/news6/487210722_1082229723932349_5232730656794461265_n.jpg',
            '/images/news-events/news6/487314567_1082229677265687_3792752858698121790_n (1).jpg',
            '/images/news-events/news6/487314567_1082229677265687_3792752858698121790_n.jpg',
            '/images/news-events/news6/487338779_1082229680599020_4556688339531800970_n.jpg',
            '/images/news-events/news6/487453576_1082229740599014_3689519830107632312_n.jpg',
            '/images/news-events/news6/487481729_1082229737265681_402694546408596699_n.jpg',
            '/images/news-events/news6/487505571_1082229437265711_1223271599498093964_n.jpg',
            '/images/news-events/news6/487959838_1082229440599044_5989265743897350598_n.jpg',
        ],
    },
    "รางวัลบุคคลคุณภาพ": {
        id: 7,
        title: "รางวัลบุคคลคุณภาพ",
        description: "จากโครงการ “บุคคลคุณภาพแห่งปี 2025”",
        imageUrl: '/images/news-events/news7/quality_person_1.jpg',
        content: `วันที่ 17 ตุลาคม 2568 ที่ผ่านมา นายไพรฑูรย์ ชารีนิวัฒน์ กรรมการผู้จัดการ บริษัท ปลาร้าเชฟไพรฑูรย์ ฟู้ดโปรดักส์ จำกัด เข้ารับโล่เชิดชูเกียรติประกาศเกียรติคุณ เป็น “บุคคลคุณภาพแห่งปี 2025” ภาคธุรกิจอาหาร
จากโครงการ “บุคคลคุณภาพแห่งปี 2025” (QUALITY PERSONS OF THE YEAR 2025)
โดยมี ฯพณฯ พลอากาศเอก จอม รุ่งสว่าง (องคมนตรี) เป็นประธานในพิธีและเป็นผู้มอบโล่เชิดชูเกียรติด้วยตนเอง
โครงการนี้จัดโดย มูลนิธิสภาวิทยาศาสตร์และเทคโนโลยีแห่งประเทศไทย (มสวท.) เพื่อเชิดชูบุคคลที่ประสบความสำเร็จในชีวิตการทำงาน และอุทิศตนสร้างคุณูปการต่อสังคมและประเทศชาติในหลากหลายด้าน อันสมควรเป็นแบบอย่างที่ดีและควรค่าต่อการส่งเสริมเกียรติยศแห่งความภาคภูมิใจ พิธีมอบรางวัลจัดขึ้น ณ ศูนย์ประชุมวายุภักษ์ โรงแรมเซ็นทารา ไลฟ์ ศูนย์ราชการและคอนเวนชันเซ็นเตอร์`,
        galleryImages: [
            '/images/news-events/news7/quality_person_1.jpg',
            '/images/news-events/news7/quality_person_2.jpg',
            '/images/news-events/news7/quality_person_3.jpg',
        ],
    },
};

export const allNewsEventsData: NewsItem[] = [
    newsData["ปลาร้าเชฟไพรฑูรย์ กินดีมีโชค 2024"],
    newsData["รณรงค์ป้องกัน แก้ปัญหา ยาเสพติด"],
    newsData["รางวัลบุคคลคุณภาพ"],
    newsData["มอบทุนการศึกษาประจำปี 2567"],
    newsData["สะพานบุญเสริมสร้างต้นทุนแกชีวิต"],
    newsData["โครงการส่งเสริมและพัฒนาคุณภาพชีวิตประชากร"],
    newsData["งานตักบาตรเทโวโรหณะ 2567"],
];
